import { Search } from '@/ui/components/atomic'
import { useRegisterChatContext } from '@/ui/components/ai-chat'
import { Pagination } from '@mui/material'
import { useState } from 'react'
import { ProductCard } from '@/ui/components/analytics-components'
import { useProducts } from '@/application/queries'
import { ReverLoading } from '@itsrever/design-system'
import { NoData } from '@/ui/shared'
import { AnalyticsFilterBar } from '@/ui/components/analytics-filters'
import { DateRangePicker, useAnalyticsDateRange } from '@/ui/shared/date-range'

function ProductsReturned() {
  useRegisterChatContext({
    tab: 'analytics',
    getPayload: () => ({ current_tab: 'analytics' })
  })

  const [freeText, setFreeText] = useState('')

  const { fromDate, toDate, range, setRange } = useAnalyticsDateRange()

  const [pageNum, setPageNum] = useState(0)
  const { products, totalPages, loading } = useProducts(
    pageNum,
    freeText,
    fromDate,
    toDate
  )

  return (
    <>
      <div className="h-full overflow-y-scroll px-8 py-4 [&::-webkit-scrollbar]:hidden">
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Search
              freeText={freeText}
              setFreeText={setFreeText}
              label="Search by name, ID"
            />
            <AnalyticsFilterBar startDate={fromDate} endDate={toDate} />
          </div>
          <div className="w-60">
            <DateRangePicker selected={range} onSelect={setRange} />
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center">
            <ReverLoading />
          </div>
        ) : products.length ? (
          <div className="grid grid-cols-[repeat(auto-fill,_minmax(210px,_1fr))] gap-4">
            {products.map((prod) => ProductCard(prod))}
          </div>
        ) : (
          <NoData />
        )}

        <div className="mt-4 flex justify-center">
          <Pagination
            onChange={(_, number) => setPageNum(number - 1)}
            count={totalPages}
            shape="rounded"
          />
        </div>
      </div>
    </>
  )
}

export default ProductsReturned
